/**
 * Copyright (c) 2021-2024 Kognitos, Inc. All rights reserved.
 */
import { Moment } from 'moment';

/**
 * Generates a URL link to the internal worker logs within a specified time range.
 *
 * @param workerId The unique identifier for the worker.
 * @param from The start time of the log range. Optional.
 * @param to The end time of the log range. Optional.
 * @returns The URL string to access the worker logs.
 */
export function getWorkerLogLink(workerId: string, from?: Moment, to?: Moment) {
  const url = new URL('https://app.datadoghq.com/logs');

  // Include all messages that include the worker id in any of the fields
  // https://docs.datadoghq.com/logs/explorer/search_syntax/#full-text-search
  url.searchParams.set('query', `*:${workerId}`);

  // Set time frame for log explorer
  // https://docs.datadoghq.com/dashboards/guide/custom_time_frames/#urls
  if (from) {
    url.searchParams.set('from_ts', from.valueOf().toString());
  }
  if (to) {
    url.searchParams.set('to_ts', to.valueOf().toString());
  }
  if (from || to) {
    url.searchParams.set('live', 'false');
  }

  return url.toString();
}
